/** Job requisitions listing domain storage. Per-tab (sessionStorage) search state and arrow-navigation batch/paging. */
import Storage from '../index';
import StorageKeys from '../keys';

const requisitions = {
    getSearchState: (lang) => Storage.get(StorageKeys.requisitionsSearchState(lang), null),
    setSearchState: (lang, state) => Storage.set(StorageKeys.requisitionsSearchState(lang), state),

    getResultBatch: () => Storage.get(StorageKeys.requisitionsBatch, null),
    setResultBatch: (hashes) => Storage.set(StorageKeys.requisitionsBatch, hashes),

    getResultPaging: () => Storage.get(StorageKeys.requisitionsPaging, null),
    setResultPaging: (paging) => Storage.set(StorageKeys.requisitionsPaging, paging),
};

export default requisitions;
